import { Grid } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";

const animations = {
  initial: {
    opacity: 0,
    x: 100,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -100,
  },
};

const AnimatedPage = (prop) => (
  <motion.div
    variants={animations}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    {prop.children}
  </motion.div>
);

export default AnimatedPage;
